/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} ConvertInputs */

const en_convert = /** @type {(inputs: ConvertInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convert`)
};

const fr_convert = /** @type {(inputs: ConvertInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convertir`)
};

const de_convert = /** @type {(inputs: ConvertInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konvertieren`)
};

const it_convert = /** @type {(inputs: ConvertInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convertire`)
};

const ru_convert = /** @type {(inputs: ConvertInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Преобразовать`)
};

const es_convert = /** @type {(inputs: ConvertInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convertir`)
};

const zh_cn2_convert = /** @type {(inputs: ConvertInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`转变`)
};

const ja_convert = /** @type {(inputs: ConvertInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`変換する`)
};

const hi_convert = /** @type {(inputs: ConvertInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बदलना`)
};

const pt_pt2_convert = /** @type {(inputs: ConvertInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Converter`)
};

/**
* | output |
* | --- |
* | "Convert" |
*
* @param {ConvertInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const convert = /** @type {((inputs?: ConvertInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<ConvertInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_convert(inputs)
	if (locale === "de") return de_convert(inputs)
	if (locale === "it") return it_convert(inputs)
	if (locale === "ru") return ru_convert(inputs)
	if (locale === "es") return es_convert(inputs)
	if (locale === "zh-CN") return zh_cn2_convert(inputs)
	if (locale === "ja") return ja_convert(inputs)
	if (locale === "hi") return hi_convert(inputs)
	if (locale === "pt-PT") return pt_pt2_convert(inputs)
	return en_convert(inputs)
});